/* eslint-disable @typescript-eslint/no-empty-function */
import { useApolloClient } from '@apollo/client';
import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { React } from 'libs/react';
import { LocalStorage } from 'libs/storage/LocalStorage';
/**
 * @component SessionProvider
 * @since 1.0.0
 */
export function SessionProvider(props) {
    const [token, setToken] = useState(LocalStorage.get('session.token'));
    const [startedAt, setStartedAt] = useState(LocalStorage.get('session.startedAt')
        ? new Date(LocalStorage.get('session.startedAt'))
        : null);
    const [expiresAt, setExpiresAt] = useState(LocalStorage.get('session.expiresAt')
        ? new Date(LocalStorage.get('session.expiresAt'))
        : null);
    const client = useApolloClient();
    useEffect(() => {
        LocalStorage.set('session.token', token);
        LocalStorage.set('session.startedAt', startedAt === null || startedAt === void 0 ? void 0 : startedAt.toISOString());
        LocalStorage.set('session.expiresAt', expiresAt === null || expiresAt === void 0 ? void 0 : expiresAt.toISOString());
    }, [token, startedAt, expiresAt]);
    /**
     * @function start
     * @since 1.0.0
     * @hidden
     */
    function start(token, startedAt, expiresAt) {
        setToken(token);
        setStartedAt(startedAt);
        setExpiresAt(expiresAt);
    }
    /**
     * @function clear
     * @since 1.0.0
     * @hidden
     */
    function clear() {
        setToken(null);
        setStartedAt(null);
        setExpiresAt(null);
        client.cache.reset();
        localStorage.clear();
    }
    const context = {
        token,
        startedAt,
        expiresAt,
        start,
        clear
    };
    return (React.createElement(SessionContext.Provider, { value: context }, props.children));
}
/**
 * @component SessionContext
 * @since 1.0.0
 */
export const SessionContext = createContext({
    token: null,
    startedAt: null,
    expiresAt: null,
    start: function () { },
    clear: function () { }
});
/**
 * @component SessionContext
 * @since 1.0.0
 */
export function useSession() {
    return useContext(SessionContext);
}
